import axios from "axios";

// State
const state = {
  responses: [],
  responsesMeta: {},
  stats: {
    total_conducted_interviews: 0,
    total_completed_interviews: 0,
    total_no_show_interviews: 0,
    total_bot_issues_interviews: 0,
  },
  selectedMeeting: null,
  meetingDetailsLoading: false,
  aiResponseStatuses: []
};

// Getters
const getters = {
  getResponsesData: (state) => state.responses,
  getResponsesMeta: (state) => state.responsesMeta,
  getInterviewStats: (state) => state.stats,
  getSelectedMeeting: (state) => state.selectedMeeting,
  getMeetingDetailsLoading: (state) => state.meetingDetailsLoading,
  getAIResponseStatuses: (state) => state.aiResponseStatuses
};

// Actions
const actions = {
  async getResponsesData({ commit }, params) {
    try {
      const response = await axios.get("/interview-requests", { params });
      commit("setResponsesData", response.data.data);
      commit("setResponsesMeta", response.data.meta);
    } catch (error) {
      console.error("Error fetching responses:", error);
    }
  },

  async getInterviewStats({ commit }) {
    try {
      const response = await axios.get("/interview-requests/stats");
      if (response.data && response.data.data && response.data.data.meta) {
        commit("setInterviewStats", response.data.data.meta);
      }
    } catch (error) {
      console.error("Error fetching interview stats:", error);
    }
  },

  async getMeetingDetails({ commit }, meetingId) {
    commit("setMeetingDetailsLoading", true);
    commit("setSelectedMeeting", null);
    try {
      const response = await axios.get(`/interview-requests/${meetingId}`);
      if (response.data && response.data.data) {
        response.data.data.persona_analysis = response.data.data.persona_analysis ? [
          response.data.data.persona_analysis,
        ]: null;
        commit("setSelectedMeeting", response.data.data);
        return response.data.data;
      }
    } catch (error) {
      console.error("Error fetching meeting details:", error);
      throw error;
    } finally {
      commit("setMeetingDetailsLoading", false);
    }
  },

  async getAIResponseStatuses({ commit }) {
    try {
      const response = await axios.get(
        `/staticContent/selectionStatuses?type=3`
      );
      if (response.data && response.data.data) {
        commit("setAIResponseStatuses", response.data.data);
        return response.data.data;
      }
    } catch (error) {
      console.error("Error fetching AI Response Statuses:", error);
      throw error;
    }
  }
};

// Mutations
const mutations = {
  setResponsesData(state, data) {
    state.responses = data;
  },
  setResponsesMeta(state, meta) {
    state.responsesMeta = meta;
  },
  setInterviewStats(state, stats) {
    state.stats = stats;
  },
  setSelectedMeeting(state, meeting) {
    state.selectedMeeting = meeting;
  },
  setMeetingDetailsLoading(state, loading) {
    state.meetingDetailsLoading = loading;
  },
  setAIResponseStatuses(state, data){
    state.aiResponseStatuses = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
